/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


window.addEventListener('scroll', function() {
  var body = document.body;
    if(window.pageYOffset > 0){
      body.classList.add("is-sticky-header");
    }
    else{
      body.classList.remove("is-sticky-header");
    }

      // STRAT: Collection Filter Sticky Script
      if($('.section-col__filters').length){
        var elementPosition = $('.col-filter__wrap').offset();        
        if($(window).scrollTop() >= elementPosition.top){
        	 $('.section-col__filters').find('.card').addClass('is-sticky__filters');
        }else {
        	$('.section-col__filters').find('.card').removeClass('is-sticky__filters');
        } 
    }
    // END: Collection Filter Sticky Script
});


//START: Custom SideBar Nav
$(document).ready(function() {
    $('#vs_SideBarNav a.dropdown-toggle').on('click', function(e) {
        var $el = $(this);
        var $parent = $(this).offsetParent(".dropdown-menu");
        $(this).parent("li").toggleClass('open');

        if(!$parent.parent().hasClass('vs_SideBarNav')) {
            $el.next().css({"top": $el[0].offsetTop, "left": $parent.outerWidth() - 4});
        }

        $('.vs_SideBarNav li.open').not($(this).parents("li")).removeClass("open");

        return false;
    });

    // for Category Menu Bar
    $('#vs_category_SideBarNav a.dropdown-toggle').on('click', function(e) {
        var $el = $(this);
        var $parent = $(this).offsetParent(".dropdown-menu");
        $(this).parent("li").toggleClass('open');

        if(!$parent.parent().hasClass('vs_category_SideBarNav')) {
            $el.next().css({"top": $el[0].offsetTop, "left": $parent.outerWidth() - 4});
        }

        $('.vs_category_SideBarNav li.open').not($(this).parents("li")).removeClass("open");

        return false;
    });


    $(".vs_mobile_sidebar_button").click(function(){        
      var $vs_drawer = $('.vs_drawer');
      if ($vs_drawer.attr("aria-hidden","true")) {
        $vs_drawer.attr("aria-hidden","false");
      }
        $("html").addClass("vs_sidebar_opened");
    });

      $("#vs-drawer__close").click(function(){        
      var $vs_drawer = $('.vs_drawer');
      if ($vs_drawer.attr("aria-hidden","flase")) {
        $vs_drawer.attr("aria-hidden","true");
      }  
        $("html").removeClass("vs_sidebar_opened");
    });
       
});
//END: Custom SideBar Nav

//START: Custom V&S collection breadcrumb
$( document ).ready(function() {
  $(document).on('click', function(event) {
        
     var targetClassName = event.target.className;
      var targetFromNavDesk = event.target.closest('.header__desktop-nav');
      var targetFromNavMob = event.target.closest('.header__mobile-nav');    
      if (targetFromNavDesk) {
        //alert('The target element is from navigation' + targetClassName);
          sessionStorage.removeItem("GetCollectionTitle");
          sessionStorage.removeItem("GetCollectionURL");
      }else if (targetFromNavMob) {
         sessionStorage.removeItem("GetCollectionTitle");
          sessionStorage.removeItem("GetCollectionURL");
      }

  });
  
      var referrer =  document.referrer;
      //console.log(referrer + 'show last element' );
  
      if($('.template-collection').length){      
        if (referrer.indexOf("collections") > -1) { 
            //Get collection URL
            if(sessionStorage.GetCollectionTitle) {
              var Get_Col_title = sessionStorage.getItem("GetCollectionTitle");
              //console.log(Get_Col_title + 'Previous collection');
            }
           if(sessionStorage.GetCollectionURL) {
              var Get_Col_url = sessionStorage.getItem("GetCollectionURL");
              //console.log(Get_Col_title + 'Previous collection ' + Get_Col_url+'handle');
            }
          var split_collection_url = referrer.split('collections/'); 
          var get_collection_handle = split_collection_url[1].split('?');
          //console.log(referrer+'  last page url '+ get_collection_handle[0] +'Title');
          if(Get_Col_title.length){
            $( "#collection_link" ).append('<a class="breadcrumb__link link" href="'+Get_Col_url+'">'+Get_Col_title+'<svg focusable="false" class="icon icon--arrow-right " viewBox="0 0 8 12" role="presentation"> <path stroke="currentColor" stroke-width="2" d="M2 2l4 4-4 4" fill="none" stroke-linecap="square"></path> </svg></a>');
         }else{
              $('#collection_link').hide();
          }    
        
        }else{
          $('#collection_link').hide();
        }
      }
  });
//END: Custom V&S collection breadcrumb